import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { TuiHintModule } from '@taiga-ui/core';
import { TuiIconModule } from '@taiga-ui/experimental';
import { TuiPaginationModule } from '@taiga-ui/kit';
import { environment } from 'src/environments/environment';

import { ExpensesDataSource } from '../data/expenses.data-source';
import { ExpensesHttpDataSource } from '../data/expenses-http.data-source';
import { ExpensesMockDataSource } from '../data/expenses-mock.data-source';

import { ExpenseStatusBadgeComponent } from '../components/expense-status-badge/expense-status-badge.component';
import { ExpenseReceiptThumbnailComponent } from '../components/expense-receipt-thumbnail/expense-receipt-thumbnail.component';
import { ExpenseReceiptModalComponent } from '../components/expense-receipt-modal/expense-receipt-modal.component';
import { ExpenseDetailSidebarComponent } from '../components/expense-detail-sidebar/expense-detail-sidebar.component';
import { ExpenseFormSidebarComponent } from '../components/expense-form-sidebar/expense-form-sidebar.component';
import { ExpenseFormLauncherService } from './expense-form-launcher.service';
import { ExpenseSummaryCardComponent } from './expense-summary-card/expense-summary-card.component';
import { ExpenseSummaryListComponent } from './expense-summary-list/expense-summary-list.component';

import { ExpenseAmountPipe } from '../pipes/expense-amount.pipe';
import { ExpenseCategoryLabelPipe } from '../pipes/expense-category-label.pipe';
import { ExpenseStatusBadgePipe } from '../pipes/expense-status-badge.pipe';

/**
 * Piezas de Gastos reutilizables fuera de su propia pantalla.
 *
 * Existe para que el desglose de precio del detalle de servicio pueda mostrar
 * los gastos del servicio sin importar `ExpensesModule` completo, que arrastraría
 * la tabla, los filtros y el formulario al bundle inicial.
 *
 * Aquí vive también el proveedor del data source, de modo que haya una sola
 * instancia compartida entre la pantalla de Gastos y el detalle de servicio.
 *
 * El formulario de alta y edición se declara aquí, y no en `ExpensesModule`,
 * porque el desglose de precio también necesita abrirlo para editar un gasto.
 * No arrastra vendor nuevo al bundle inicial: `ng-select` y los módulos de
 * formularios ya están en el `SharedModule` de la aplicación.
 */
@NgModule({
  declarations: [
    ExpenseStatusBadgeComponent,
    ExpenseReceiptThumbnailComponent,
    ExpenseReceiptModalComponent,
    ExpenseDetailSidebarComponent,
    ExpenseFormSidebarComponent,
    ExpenseSummaryCardComponent,
    ExpenseSummaryListComponent,
    ExpenseAmountPipe,
    ExpenseCategoryLabelPipe,
    ExpenseStatusBadgePipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    TranslateModule.forChild(),
    TuiHintModule,
    TuiIconModule,
    TuiPaginationModule,
  ],
  exports: [
    ExpenseStatusBadgeComponent,
    ExpenseReceiptThumbnailComponent,
    ExpenseDetailSidebarComponent,
    ExpenseFormSidebarComponent,
    ExpenseSummaryCardComponent,
    ExpenseSummaryListComponent,
    ExpenseAmountPipe,
    ExpenseCategoryLabelPipe,
    ExpenseStatusBadgePipe,
  ],
  providers: [
    // Abrir el formulario y guardar: lo usan la pantalla de Gastos y el desglose
    // de precio del detalle de servicio.
    ExpenseFormLauncherService,
    {
      // Único punto donde se decide mock vs API real.
      provide: ExpensesDataSource,
      useClass: environment.features.expensesMock
        ? ExpensesMockDataSource
        : ExpensesHttpDataSource,
    },
  ],
})
export class ExpensesSharedModule {}
